import type { AnnotationsTooltipProps } from '../../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';

/** XYChart Annotations.Tooltip subcomponent props */
export const AnnotationsTooltip = (props: AnnotationsTooltipProps) => null;

AnnotationsTooltip['displayName'] = 'XYChartAnnotations.Tooltip';
